import { Button } from '@mui/material';
import { Assessment, Close } from '@mui/icons-material';
import { useReportGenerator } from '../../hooks/useReportGenerator';
import './ReportButton.css';

interface ReportButtonProps {
  userId: string;
  jwtToken: string;
  facilityId: number;
  websocketUrl: string;
}

export function ReportButton({
  userId,
  jwtToken,
  facilityId,
  websocketUrl
}: ReportButtonProps) {
  const { isGenerating, progress, message, error, generateReport, cancelReport } =
    useReportGenerator({ userId, jwtToken, websocketUrl });

  const handleClick = () => {
    if (isGenerating) {
      cancelReport();
    } else {
      // Campus-wide active trailers: only the anchor is sent; the server expands the campus.
      generateReport({
        template_uuid: 'rpt_tpl_001_campus',
        facility_id: facilityId,
        runtime_params: { facility_id: facilityId }
      });
    }
  };

  return (
    <div className="report-button-container">
      <Button
        variant="contained"
        color={isGenerating ? 'error' : 'primary'}
        size="small"
        startIcon={isGenerating ? <Close /> : <Assessment />}
        onClick={handleClick}
        disabled={!!error}
        sx={{
          fontSize: { xs: '0.7rem', sm: '0.8rem' },
          minWidth: 'auto',
          px: { xs: 1, sm: 2 }
        }}
      >
        {isGenerating ? 'Cancel Report' : 'Generate Report'}
      </Button>

      {isGenerating && (
        <div className="progress-container">
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }} />
          </div>
          <p className="progress-message">
            {message} ({progress}%)
          </p>
        </div>
      )}

      {error && (
        <div className="error-message">
          <p>❌ {error}</p>
        </div>
      )}
    </div>
  );
}
